import { useMemo, useState } from 'react'
import { BsBank2, BsFillWalletFill } from 'react-icons/bs'
import { FaRegMoneyBillAlt } from 'react-icons/fa'
import { GiMoneyStack } from 'react-icons/gi'
import { HiDotsVertical } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { IBank, IFoodOrder, IFoodOrderProduct, IFoodTable } from 'safe'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { Box, Card, Fade, Popover, Popper } from '@mui/material'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import React from 'react'
import Button from '../../components/General/Button'
// import EditAccountForm from './EditAccountForm'
import Delivery from '../../assets/images/delivery.svg'
import Pickup from '../../assets/images/pick_up.svg'
import Restaurant from '../../assets/images/restaurant.svg'
import { RootState } from '../../redux/store'
import { FiTrash2 } from 'react-icons/fi'


const rolesAllowedToCloseFoodOrder = ['admin', 'master', 'cashier']

const FoodOrderCard: React.FC<FoodOrderCardProps> = ({
  order,
  fromSafeBox = false,
  onPressCardProp = () => null,
  banks = [],
  onEdit,
  onDelete,
  onWatch,
  onAddProduct,
  onChangeStatus,
  onAssignProducts,
  visibleMenu,
  setVisibleMenu,
  onChangeStatusProduct,
  onCloseOrder,
  onPrintOrder,
  onDeleteItem,
}) => {
  const [modalDescription, setModalDescription] = useState<boolean>(false)
  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)
  const [editModal, setEditModal] = useState<boolean>(false)
  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const user = useSelector((state: RootState) => state?.auth?.user)

  const { addAlert } = useSnackBars()

  const onPressCard = () => {}

  const dispatch = useDispatch()

  const toggle = (): void => {
    setVisibleMenu('')
  }

  const setVisible = async (wantedState: boolean) => {
    try {
      addAlert({
        message: 'Actualizando cuenta...',
        status: 'loading',
      })
      //   await dispatch(setAccountVisible(String(table.id), wantedState))
      addAlert({
        message: 'Visibilidad actualizada con éxito',
        status: 'success',
      })
    } catch (error: any) {
      addAlert({
        message:
          error.response.data.message ||
          'Error al modificar disponibilidad en cuenta',
        status: 'error',
      })
    } finally {
      toggle()
    }
  }

  const userHasPermissionToCloseFoodOrder = useMemo(() => {
    return rolesAllowedToCloseFoodOrder.includes(user['custom:user_role'])
  }, [user])

  return (
    <>
      <ModalViewWithTabs
        display={modalDescription}
        onClose={() => {
          setModalDescription(false)
        }}
        dataWithTabs={dataWithTabs}
      />

      <div
        key={order.id}
        className="shadow-lg rounded-lg w-full"
        onClick={() => onPressCardProp()}
      >
        <div className="bg-primary dark:bg-primary-dark w-full h-[120px] p-[10px] rounded-t-lg shadow-lg">
          <div className="flex justify-between">
            <div className="flex flex-row items-center">
              <div className="mr-[5px]">
                <div
                  className="p-[4px] flex justify-center items-center rounded-md"
                  style={{
                    backgroundColor:
                      order?.type === 'delivery'
                        ? '#9D32CF'
                        : order?.type === 'pickup'
                        ? '#AE0D36'
                        : '#e08500',
                  }}
                >
                  <img
                    className="w-[25px] h-[25px]"
                    src={
                      order?.type === 'delivery'
                        ? Delivery
                        : order?.type === 'pickup'
                        ? Pickup
                        : Restaurant
                    }
                    alt="logo-zerux"
                  />
                </div>
              </div>

              <div className="truncate text-sm font-bold max-h-10 text-white">
                Orden Nro: {order?.foodOrderCode}
              </div>
            </div>

            <HiDotsVertical
              className="cursor-pointer text-white"
              onClick={(e: any) => {
                setAnchorEl(e.currentTarget)
                setVisibleMenu(order.id)
              }}
            />

            <Popover
              id={visibleMenu === order.id ? 'simple-popper' : undefined}
              open={visibleMenu === order.id}
              anchorEl={anchorEl}
              onClose={() => {
                setAnchorEl(null)
                setVisibleMenu('')
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <Box
                className="dark:border-gray-800 w-48 shadow-md rounded p-2"
                sx={{
                  bgcolor: 'background.paper',
                  borderColor: 'background.paper',
                }}
              >
                <div
                  key={'Imprimir'}
                  className="py-1"
                  onClick={() => {
                    onPrintOrder && onPrintOrder(order)
                    setAnchorEl(null)
                    setVisibleMenu('')
                  }}
                >
                  <Button type="link" classes="text-black hover:text-primary">
                    {'Imprimir'}
                  </Button>
                </div>

                { userHasPermissionToCloseFoodOrder && (
                  <div
                    key={'Cerrar'}
                    className="py-1"
                  onClick={() => {
                    onCloseOrder && onCloseOrder(order)
                    setAnchorEl(null)
                    setVisibleMenu('')
                  }}
                >
                  <Button type="link" classes="text-black hover:text-primary">
                    {'Cerrar'}
                    </Button>
                  </div>
                )}

                <div
                  key={'Asignar artículos'}
                  className="py-1"
                  onClick={() => {
                    onAssignProducts && onAssignProducts(order)
                    setAnchorEl(null)
                    setVisibleMenu('')
                  }}
                >
                  <Button type="link" classes="text-black hover:text-primary">
                    {'Asignar artículos'}
                  </Button>
                </div>

                <div
                  key={'Editar'}
                  className="py-1"
                  onClick={() => {
                    onEdit && onEdit(order)
                    setAnchorEl(null)
                    setVisibleMenu('')
                  }}
                >
                  <Button type="link" classes="text-black hover:text-primary">
                    {'Editar'}
                  </Button>
                </div>

                {/* <div
                  key={order?.active ? 'Deshabilitar' : 'Habilitar'}
                  className="py-1"
                  onClick={() => {
                    onChangeStatus && onChangeStatus(order)
                    setAnchorEl(null)
                    setVisibleMenu('')
                  }}
                >
                  <Button type="link" classes="text-black hover:text-primary">
                    {order?.active ? 'Deshabilitar' : 'Habilitar'}
                  </Button>
                </div> */}

                { user && user['custom:user_role'] !== 'waiter' && (
                  <div
                    key={'Eliminar'}
                    className="py-1"
                  onClick={() => {
                    onDelete && onDelete(order.id)
                    setAnchorEl(null)
                    setVisibleMenu('')
                  }}
                >
                  <Button type="link" classes="text-black hover:text-primary">
                    {'Eliminar'}
                  </Button>
                </div>
                )}
              </Box>
            </Popover>

            {/* <FloatingMenu
              onClose={() => {
                setVisibleMenu('')
              }}
              visible={visibleMenu === order.id}
              options={{
                onCustomButtons: [
                  {
                    title: 'Asignar artículos',
                    action: () => onAssignProducts && onAssignProducts(order),
                    display: true,
                  },
                  {
                    title: 'Editar',
                    action: () => onEdit && onEdit(order),
                    display: true,
                  },
                  {
                    title: order?.active ? 'Deshabilitar' : 'Habilitar',
                    action: () => onChangeStatus && onChangeStatus(order),
                    display: true,
                  },
                  {
                    title: 'Eliminar',
                    action: () => onDelete && onDelete(order.id),
                    display: true,
                  },
                ],
              }}
            >
              <HiDotsVertical
                className="cursor-pointer text-white"
                onClick={() => setVisibleMenu(order.id)}
              />
            </FloatingMenu> */}
          </div>

          <div className="truncate text-sm max-h-10 text-white mt-[10px]">
            Mesa: {order?.foodTable?.name}
          </div>

          <div className="truncate text-sm max-h-10 text-white">
            {order?.date && (
              <div className="truncate text-sm max-h-10 text-white">
                Fecha:{' '}
                {new Date(order.date).toLocaleDateString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })}
              </div>
            )}
          </div>

          {/* <div className="truncate text-sm max-h-10 text-white">
            Estado: {order?.active ? 'Habilitada' : 'Deshabilitada'}
          </div> */}

          {/* <div className="truncate text-sm max-h-10 text-white">
            Tipo: {order?.type}
          </div> */}
        </div>

        <div className="p-[20px] dark:bg-black">
          {order?.items.length === 0 && (
            <div className="flex justify-center items-center h-full">
              <div className="text-sm text-gray-500">
                No hay productos en esta comanda
              </div>
            </div>
          )}

          {order?.items.map((product) => (
            <div className="flex mt-[10px] dark:bg-black justify-between">
              <div className='flex'>
              <div>
                <div
                  className="h-[100%] w-[10px] cursor-pointer bg-primary rounded-full"
                  style={{
                    backgroundColor:
                      product.status === 'pending'
                        ? '#f51b1b'
                        : product.status === 'ready'
                        ? '#f5b41b'
                        : '#4D9D44',
                  }}
                  onClick={() => {
                    onChangeStatusProduct(order, product)
                  }}
                ></div>
              </div>

              <div className="truncate text-sm max-h-10 dark:text-white mt-[10px] ml-[10px]">
                {product?.name}
              </div>
              </div>

              
            <Button
              classes="border-none"
              onClick={() => {
                onDeleteItem(product)
              }}
            >
              <FiTrash2 size={20} color="red" />
            </Button>
              
            </div>
          ))}
        </div>

        {/* <div className="h-8 flex items-center">
            <div className="flex items-center truncate text-primary-600 font-medium">
              <div className="mr-4">
                <FaRegMoneyBillAlt
                  size="0.9rem"
                  className="dark:text-white text-dark"
                />
              </div>
              <div className="truncate text-sm max-h-10 dark:text-white">
                {order?.idFoodTable}
              </div>
            </div>
          </div>

          <div>
            <div className="text-sm max-h-10 dark:text-white">
              Dale Clic a "Habilitar" para abrir un nuevo servicio.
            </div>
          </div> */}
      </div>

      {/* {!fromSafeBox && (
          <FloatingMenu
            onClose={() => {
              setVisibleMenu(false)
            }}
            visible={visibleMenu}
            options={{
              onCustomButtons: [
                {
                    title: 'Agregar Producto',
                    action: () => onAddProduct && onAddProduct(order),
                    display: true,
                  },
                {
                  title: 'Ver',
                  action: () => {
                    onWatch && onWatch()
                  },
                  display: true,
                },
              
                {
                  title: 'Editar Mesa',
                  action: () => onEdit && onEdit(order),
                  display: true,
                },
                {
                  title: 'Eliminar',
                  action: () => setDisplayConfirm(true),
                  display: true,
                },
               
              ],
            }}
          >
            <HiDotsVertical
              className="cursor-pointer text-gray-400"
              onClick={toggle}
            />
          </FloatingMenu>
        )} */}

      <ModalConfirm
        title={'¿Está seguro que desea eliminar esta comanda?'}
        displayConfirmModal={displayConfirm}
        onConfirm={() => onDelete && onDelete(order.id)}
        onCancel={() => setDisplayConfirm(false)}
      ></ModalConfirm>
    </>
  )
}

interface FoodOrderCardProps {
  order: IFoodOrder | any
  fromSafeBox?: boolean
  onPressCardProp?: Function
  onEdit?: Function
  banks?: IBank[]
  onDelete?: Function
  onWatch?: Function
  onAddProduct?: Function
  onChangeStatus?: Function
  onAssignProducts?: Function
  visibleMenu: string
  setVisibleMenu: (visibleMenu: string) => void
  onChangeStatusProduct: (order: IFoodOrder, product: IFoodOrderProduct) => void
  onCloseOrder: (order: IFoodOrder) => void
  onPrintOrder: (order: IFoodOrder) => void
  onDeleteItem: (item: IFoodOrderProduct) => void
}

export default FoodOrderCard
